const syncFormFileField = (input) => {
  const control = input.closest(".form-file-field__control")
  if (!control) return

  const nameEl = control.querySelector("[data-form-file-name]")
  if (!nameEl) return

  const file = input.files?.[0]
  nameEl.textContent = file ? file.name : ""
}

const bindFormFileField = (root) => {
  if (root.dataset.bound === "true") return

  const input = root.querySelector(".form-file-field__input")
  const trigger = root.querySelector("[data-form-file-trigger]")
  if (!input || !trigger) return

  root.dataset.bound = "true"

  trigger.addEventListener("click", (event) => {
    event.preventDefault()
    input.click()
  })

  input.addEventListener("change", () => {
    syncFormFileField(input)
  })

  syncFormFileField(input)
}

const initFormFileField = () => {
  document.querySelectorAll(".form-file-field").forEach(bindFormFileField)
}

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll(".form-file-field").forEach((root) => {
    root.dataset.bound = "false"
  })
})

export { initFormFileField }
